// Bearer (JWT) logout transport (ENG-1518 / H1).
//
// Ends a switched / break-glass session server-side: the backend (JWTLogoutView)
// blacklists the refresh token and clears the HttpOnly `refresh_token` cookie, so
// `POST /auth/jwt/refresh/` can no longer mint access tokens after logout. Like the
// refresh call, it carries no Authorization header — it relies on the path-scoped
// `refresh_token` cookie (`credentials: "include"`) and echoes the `csrftoken`
// cookie back via `X-CSRFToken`.
//
// Best-effort: client-side teardown must always proceed, so every failure is
// swallowed. `baseUrl` is passed in (not read from `import.meta`) so this module
// stays unit-testable under ts-jest.
import { getCsrfToken } from "utils/auth-header.util";

// Mounted UNDER the refresh path because the `refresh_token` cookie is path-scoped
// to `/auth/jwt/refresh/` — only a URL beneath it receives the cookie the backend
// needs to read and blacklist.
const LOGOUT_PATH = "/auth/jwt/refresh/logout/";

export const revokeBearerSession = async (baseUrl: string): Promise<void> => {
  try {
    await fetch(`${baseUrl}${LOGOUT_PATH}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": getCsrfToken()
      }
    });
  } catch {
    // Best-effort — the caller tears down the client session regardless.
  }
};
